import apiClient from "@/services/apiClient";

const fileNameFromDisposition = (disposition, fallback) => {
  const match = /filename\*=UTF-8''([^;]+)|filename="?([^"]+)"?/i.exec(disposition || "");
  return decodeURIComponent(match?.[1] || match?.[2] || fallback);
};

const saveBlob = (response, fallbackFileName) => {
  const blob = response?.data instanceof Blob ? response.data : new Blob([response?.data]);
  const fileName = fileNameFromDisposition(response?.headers?.["content-disposition"], fallbackFileName);
  const objectUrl = URL.createObjectURL(blob);
  const link = window.document.createElement("a");
  link.href = objectUrl;
  link.download = fileName;
  link.click();
  window.setTimeout(() => URL.revokeObjectURL(objectUrl), 1000);
};

export const enrollmentDocumentService = {
  downloadStudentEnrollment: async (studentBookingId, bookingNumber = "") => {
    const response = await apiClient.get("/StudentEnrollment/DownloadEnrollment", {
      params: { pStudentBookingId: studentBookingId },
      responseType: "blob",
    });
    saveBlob(response, `Booking Enrollemnt-${bookingNumber || studentBookingId}.docx`);
  },
  downloadAdminEnrollment: async (studentBookingId, bookingNumber = "") => {
    const response = await apiClient.get("/AdminEnrolment/DownloadEnrollment", {
      params: { pStudentBookingId: studentBookingId },
      responseType: "blob",
    });
    saveBlob(response, `Booking Enrollemnt-${bookingNumber || studentBookingId}.docx`);
  },
};
